import { render, staticRenderFns } from "./OpenScreenList.vue?vue&type=template&id=570cd3f6&scoped=true&"
import script from "./OpenScreenList.vue?vue&type=script&lang=js&"
export * from "./OpenScreenList.vue?vue&type=script&lang=js&"
import style0 from "./OpenScreenList.vue?vue&type=style&index=0&id=570cd3f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570cd3f6",
  null
  
)

export default component.exports